module.exports = __webpack_public_path__ + "img/icon_ser.0623d59.webp";